// const GET_SERVER = 'https://readonly.clickpost.in';
const POST_SERVER = 'https://api.clickpost.ai';
const TRACKING_SERVER =
  'https://tracking-dot-clickpost-backend.uc.r.appspot.com';
const APP_URL = '';
const STAGING2 = 'https://api.clickpost.ai';
const DS_SERVER = 'https://api.clickpost.ai';
var API_V1 = '/api/v1';
var API_V2 = '/api/v2';

const APIs = {
  APP: {
    ENCRYPT: `${APP_URL}${API_V1}/encrypt`
  },
  META_DATA: {
    GET: `${POST_SERVER + API_V1}/alerting/alert_metadata/?`,
    SERVICE: `${POST_SERVER + API_V1}/dashboard/alert_metadata/?`
  },
  ALERT: {
    GET: `${POST_SERVER + API_V1}/alerting/all/alert/?`,
    POST: `${POST_SERVER + API_V1}/alerting/all/alert/?`,
    UPDATE: `${POST_SERVER + API_V1}/alerting/alert/update/?`,
    REBOOT: `${POST_SERVER + API_V1}/alerting/reboot_instance_api/?`
  },
  STATUSES: {
    UNMAPPED: `${POST_SERVER + API_V1}/tracking_status/unmapped_uber_status?`,
    MAPPED: `${POST_SERVER + API_V1}/tracking/uber-status-update/?`,
    // UPDATE: `${POST_SERVER + API_V1}/tracking_status/unmapped_uber_status?`
    UPDATE: `${TRACKING_SERVER + API_V1}/tracking/uberStatusMapping?` // for tracking server
  },
  JOBS: `${POST_SERVER + API_V1}/alerting/clickpost_jobs/?`,
  ACTIVE_REPORTS: {
    META_DATA: `${POST_SERVER + API_V1}/reports/active-reports-metadata/?`,
    FETCH: `${POST_SERVER + API_V1}/reports/all-reports/?`
  },
  REPORT_METADATA: `${POST_SERVER + API_V1}/reports/doc/?`,
  NEW_REPORT_METADATA: `${POST_SERVER + API_V2}/reports/metadata/?`,
  REPORT_DOWNLOAD: `${POST_SERVER +
    API_V1}/reports/download_scheduled_report/?`,
  SET_REPORT_TZ: `${POST_SERVER + API_V1}/reports/report-timezone-config/?`,
  SHIPPING_LABEL: {
    META_DATA: `${POST_SERVER +
      API_V1}/admin/shipping-label-operation-metadata?`,
    FETCH: `${POST_SERVER + API_V1}/admin/shipping-label-operation?`,
    SAMPLE: `${POST_SERVER + API_V1}/admin/shipping-label-template?`,
    REGENERATE: `${POST_SERVER + API_V1}/fetch/shippinglabel/?regenerate=true&`
  },
  EMAIL_TEMPLATE: {
    META_DATA: `${POST_SERVER + API_V1}/dashboard/notification_metadata/?`,
    FETCH: `${POST_SERVER + API_V1}/dashboard/email-template?`
  },
  SHIPMENT_LOG: {
    FETCH: `${POST_SERVER + API_V1}/fetch/rr_logging/?`,
    ASYNC: `${POST_SERVER + API_V1}/async_request/?`,
    ASYNC_METADATA: `${POST_SERVER + API_V1}/job_logs_metadata/?`,
    SCANS: `${POST_SERVER + API_V1}/internal/awb-tracking-details/?`,
    SMS_NOTIFICATION: `${POST_SERVER + API_V1}/sms_history/?`,
    EMAIL_NOTIFICATION: `${POST_SERVER + API_V1}/email_history/?`
  },
  QC_PARAMETER: {
    FETCH: `${POST_SERVER + API_V1}/dashboard/courier_partner_qc_fields/?`,
    POST: `${POST_SERVER + API_V1}/dashboard/courier_account_qc/?`,
    COURIER_ACCOUNTS: `${POST_SERVER +
      API_V1}/internal_dashboard/courier_accounts/?`
  },
  COURIER_ACCOUNTS: `${POST_SERVER +
    API_V1}/internal_dashboard/courier_accounts/?`,
  S3_PRESIGNED_URL: `${POST_SERVER +
    API_V1}/file_upload/generate_presigned_url/?`,
  REPLICATE_S3_FILE: `${POST_SERVER + API_V1}/file_upload/replicate-file?`,
  BILLING: {
    FETCH: `${POST_SERVER + API_V1}/billing/monthly-counts/?`,
    FETCH_ALL: `${POST_SERVER + API_V1}/billing/get-all-rules/?`,
    RULE_META_DATA: `${POST_SERVER + API_V1}/billing/get-all-rules/?`,
    META_DATA: `${POST_SERVER + API_V1}/billing/get-billing-types/?`,
    SERVICE_META_DATA: `${POST_SERVER + API_V1}/billing/get-all-services/?`,
    POST: `${POST_SERVER + API_V1}/billing/create-enterprise-service-rules/?`,
    FETCH_BILLING: `${POST_SERVER +
      API_V1}/billing/get-enterprise-service-rules/?`,
    THRESHOLD: {
      FETCH: `${POST_SERVER + API_V1}/billing/get-enterprise-threshold/?`,
      POST: `${POST_SERVER + API_V1}/billing/create-enterprise-threshold/?`
    },
    PAYMENT: {
      FETCH: `${POST_SERVER + API_V1}/billing/get-enterprise-payment/?`,
      POST: `${POST_SERVER + API_V1}/billing/create-enterprise-payment/?`
    }
  },
  TRACKING_DELAY: {
    FETCH: `${POST_SERVER + API_V1}/analytics/tracking_delay/?`,
    FETCH_PERCENTILE: `${POST_SERVER +
      API_V1}/analytics/tracking_delay_percentile/?`
  },
  ORDER_CREATION: `${POST_SERVER + API_V1}/api_stats/?`,
  COURIER_PARTNER: `${POST_SERVER + API_V2}/flash/enterprise-detail/?`,
  WAREHOUSE: {
    FETCH: `${POST_SERVER + API_V1}/unmapped_courier_location/?`
  },
  GENERATE_REPORT: `${POST_SERVER + API_V2}/dashboard/download_tracking_data/?`,
  RELEASE_NOTES: `${POST_SERVER + API_V1}/dashboard/release_note/?`,
  DASHBOARD_LOGIN: `${APP_URL + API_V1}/dashboard-login?`,
  GENERATE_TOKEN: `${POST_SERVER + API_V1}/dashboard/internal-user-token/`,
  SSO_AUTH: `${POST_SERVER}${API_V1}/sso/auth/?provider=GoogleOAuth`,
  TOKEN_EXCHANGE: `${API_V1}/token-exchange`,
  LOGIN: `${API_V1}/login`,
  SSO_TOKEN: `${POST_SERVER}${API_V1}/sso/token?`,
  FONT: `${POST_SERVER}/api/return-plugin/v1/font/`,
  DATA_ERASURE: `${POST_SERVER + API_V1}/alerting/data_erasure_api/`,
  TRACKING_HEALTH: `${TRACKING_SERVER}/health`, // To debug tracking server cors issue
  AUDIT_LOG: {
    SERVICE_NAMES: `${POST_SERVER + API_V1}/audit-log/service-names`,
    ENTERPRISE_SERVICES: `${POST_SERVER + API_V1}/audit-log/enterprise-services`
  },
  FIREBASE: {
    GET: `${APP_URL + API_V1}/feature-activation`,
    'HLD-ENTERPRISES': `${APP_URL + API_V1}/hld-enterprises`
  },
  NPS: {
    CUSTOM_QUESTIONS: `${POST_SERVER + API_V1}/nps_custom_questions/?`
  },
  DASHBOARD_PERMISSION: `${APP_URL + API_V1}/dashboard-permission?`,
  DASHBOARD_BILLING_ALERTS: `${APP_URL + API_V1}/dashboard/billing-alerts?`,
  DASHBOARD_LOGIN_CREATIVES: `${APP_URL + API_V1}/login-page-creatives`,
  WALKTHROUGH_CONFIGS: `${APP_URL + API_V1}/walkthrough-configs`,
  CONFIGURE_AWB_SERIES: `${POST_SERVER +
    API_V1}/enterprise-awb-series-config/?`,
  REDSHIFT_LATENCY: `${POST_SERVER}/data-pipeline${API_V1}/table_summary/?`,
  SIMULATION: {
    RUN: `${POST_SERVER + API_V1}/simulation-run/?`,
    CONFIG: `${POST_SERVER + API_V1}/simulation-config/?`
  },
  COD_TO_PREPAID: `${POST_SERVER + API_V1}/cod-to-prepaid/dashboard-trigger/?`,
  USER: {
    ACCESS: `${APP_URL + API_V1}/dashboard/user-access/`,
    SELF_ACCESS: `${APP_URL + API_V1}/dashboard/user-access/me`,
    ENTERPRISES: `${APP_URL + API_V1}/dashboard/user/enterprises?`
  },
  FEATURE_ENVS: `${APP_URL + API_V1}/feature-environments`,
  BETA_RELEASE: `${APP_URL + API_V1}/feature-flags`,
  TRACKING_PAGE_STYLING: `${POST_SERVER +
    API_V1}/dashboard/tracking_page_styling/?`,
  RETURN_CONFIGS: `${STAGING2 +
    API_V1}/fetch-enterprise-return-exchange-configs/?`,
  EDD_ALERTS: `${DS_SERVER + API_V1}/eddmodelview/?`,
  MANIFEST: {
    LIST: `${POST_SERVER + API_V1}/dashboard/manifest-list/?`,
    DL_EMAILS: `${POST_SERVER + API_V1}/dashboard/email-dl/?`,
    NEXT_RUN_TIME: `${POST_SERVER +
      API_V1}/dashboard/manifestation-generation-time/?`,
    RETRIGGER: `${POST_SERVER + API_V1}/dashboard/retrigger-manifest`,
    REGENERATE: `${POST_SERVER + API_V1}/dashboard/manifest-regenerate`,
    MANUAL_GENERATE: `${POST_SERVER +
      API_V1}/dashboard/manual-generate-manifest`
  },
  ANALYTICS: `${POST_SERVER + API_V1}/fetch/hld_landing_page_analytics/?`,
  SMART_COMMUNICATION: {
    TEMPLATE_MIGRATION: `${POST_SERVER +
      API_V1}/smart-communication/template_migration`,
    JOURNEY_MIGRATION: `${POST_SERVER +
      API_V1}/smart-communication/journey_migration`
  },
  NOTIFICATIONS_SMART_MIGRATION_LOGS: `${APP_URL +
    API_V1}/notifications-smart-migration-logs`
};

const KEYS = {
  FILE_UPLOAD: '040930c4-25d6-4fd6-80dc-fd31da28be92'
};

export { APIs, KEYS };
